export const ANIMATIONS = {
  duration: 500,
};

export default ANIMATIONS;
